const getters = {
  nextQuestion (state) {
    for (let i = 0; i < state.questions.length; i++) {
      const question = state.questions[i]
      if (question.path === state.currentQuestion.path) {
        if (i === state.questions.length - 1) {
          return null
        }
        return state.questions[i + 1]
      }
    }
  }
}
export default getters
